module.exports = __webpack_public_path__ + "media/images/pic/video/1-44f3b9ab07e3389a077f4f2754b9f0e7.jpeg";